<template>
  <div class="layout-card" style="height: 100%; overflow-y: auto">
    <div style="margin-bottom: 20px">
      <Button type="text" icon="ios-arrow-back" @click="handleBack"
        >返回</Button
      >
    </div>

    <div
      style="
        position: absolute;
        top: 50px;
        right: 50px;
        display: flex;
        justify-content: flex-end;
      "
    >
      <div class="step-indicator vertical">
        <div
          class="step-item"
          :class="{ active: currentStep === 1, completed: currentStep > 1 }"
        >
          <div class="step-title">实验对象设置</div>
          <div class="step-number">
            {{ currentStep === 1 ? '1' : currentStep > 1 ? '✓' : '1' }}
          </div>
        </div>
        <div
          class="step-line vertical"
          :class="{
            active: currentStep > 1,
            completed: !!form.experimentStatus
          }"
        ></div>
        <div
          class="step-item"
          :class="{
            active: currentStep === 2,
            completed: !!form.experimentStatus
          }"
        >
          <div class="step-title">具体方案设置</div>
          <div class="step-number">{{ form.experimentStatus ? '✓' : '2' }}</div>
        </div>
      </div>
    </div>

    <Form
      ref="formRef"
      v-if="currentStep === 1"
      :model="form"
      style="
        display: flex;
        flex-direction: column;
        gap: 20px;
        max-width: calc(100% - 100px);
      "
      :label-width="120"
    >
      <Step1
        :options="options"
        :formData="form"
        :readonly="false"
        @featureSelected="handleFeatureSelected"
      />

      <div class="button-group">
        <div style="display: flex; justify-content: flex-end; gap: 20px">
          <Button @click="handleBack">取消</Button>
          <Button type="primary" @click="handleNext">下一步</Button>
        </div>
      </div>
    </Form>

    <Form
      ref="formRef"
      v-else
      :model="form"
      style="
        display: flex;
        flex-direction: column;
        max-width: calc(100% - 100px);
      "
      :label-width="120"
    >
      <Step1 :options="options" :formData="form" :readonly="true" />
      <Step2
        ref="step2Ref"
        :formData="form"
        @back="handlePrevious"
        :mode="mode"
      />

      <div class="button-group">
        <div style="display: flex; gap: 20px">
          <Button
            type="success"
            :loading="loading"
            @click="handleSaveAndStart"
            v-if="!form.experimentStatus"
          >
            保存并开始实验
          </Button>
          <Button
            type="primary"
            :loading="loading"
            @click="handleSaveOnly"
            v-if="!form.experimentStatus"
          >
            仅保存
          </Button>
          <Button
            type="primary"
            :loading="loading"
            @click="handleSaveOnly"
            v-if="form.experimentStatus && mode !== 'view'"
          >
            保存修改
          </Button>
          <Button @click="handleBack" v-if="mode !== 'view'">取消</Button>
        </div>
        <div>
          <Poptip
            v-if="form.experimentStatus && mode !== 'view'"
            confirm
            title="确定要终止吗？"
            transfer
            @on-ok="handleStop"
          >
            <Button type="error" :loading="stopLoading">终止实验</Button>
          </Poptip>
        </div>
      </div>
    </Form>

    <Modal
      v-model="cancelModalVisible"
      title="确认取消"
      @on-ok="confirmCancel"
      @on-cancel="cancelModalVisible = false"
    >
      <p>确定要取消当前实验设置吗？所有未保存的内容将丢失。</p>
    </Modal>
  </div>
</template>

<script>
import { addAbTest, editAbTest, stopAbTest } from '@/api/abtest'
import {
  buildExperimentSubmitData,
  createExperimentForm,
  syncControlGroupParamByCapability
} from '../helpers'
import Step1 from './Step1.vue'
import Step2 from './Step2.vue'

export default {
  name: 'AddExperiment',
  components: {
    Step1,
    Step2
  },
  props: {
    options: {
      type: Object,
      default: () => ({
        capabilitieList: []
      })
    },
    editData: {
      type: Object,
      default: null
    },
    mode: {
      type: String,
      default: 'add'
    }
  },
  data() {
    const form = createExperimentForm()
    return {
      loading: false,
      stopLoading: false,
      originForm: JSON.stringify(form),
      currentStep: 1,
      form,
      cancelModalVisible: false
    }
  },
  methods: {
    handleFeatureSelected() {
      syncControlGroupParamByCapability(this.form)
      this.form.controlGroupId = ''
      this.form.controlGroupName = '对照组'
      this.form.controlGroupParticipateRatio = 0
      this.form.groups = []
    },
    handleBack() {
      if (this.mode === 'view') {
        this.$emit('back')
        return
      }

      if (this.originForm !== JSON.stringify(this.form)) {
        this.cancelModalVisible = true
        return
      }

      this.$emit('back')
    },
    handleStop() {
      if (this.stopLoading) return
      this.stopLoading = true

      stopAbTest(this.form.id)
        .then(() => {
          this.$Message.success('实验已终止')
          this.$emit('back')
        })
        .catch((err) => {
          this.$Message.error(err.msg || '实验终止失败')
        })
        .finally(() => {
          this.stopLoading = false
        })
    },
    confirmCancel() {
      this.cancelModalVisible = false
      this.$emit('back')
    },
    handleNext() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.currentStep = 2
          this.$nextTick(() => {
            this.$refs.step2Ref.handleGetDefaultGroup()
          })
        } else {
          this.$Message.error('请填写完整步骤1的必填项')
        }
      })
    },
    handlePrevious() {
      if (this.$refs.step2Ref) {
        this.$refs.step2Ref.resetForm()
      }
      this.currentStep = 1
    },
    handleSaveOnly() {
      this.saveExperiment(false)
    },
    handleSaveAndStart() {
      this.saveExperiment(true)
    },
    saveExperiment(action) {
      if (this.$refs.step2Ref && !this.$refs.step2Ref.validateFeatureConfig()) {
        return
      }

      const forms = this.$refs.step2Ref.getFormData()
      this.form.controlGroupParticipateRatio = Number(
        forms.trafficDistribution[0]
      )
      this.form.groups.forEach((group, index) => {
        group.participateRatio = Number(forms.trafficDistribution[index + 1])
      })

      this.$refs.formRef.validate((valid) => {
        if (!valid) {
          this.$Message.error('请填写完整所有必填项')
          return
        }

        this.loading = true

        if (!this.form.id) {
          const submitData = buildExperimentSubmitData(this.form, action)
          addAbTest(submitData)
            .then(() => {
              this.$Message.success('实验保存成功')
              this.$emit('submit', submitData)
            })
            .catch((err) => {
              this.$Message.error(err.msg || '实验保存失败')
            })
            .finally(() => {
              this.loading = false
            })
          return
        }

        if (this.form.experimentStatus === 0) {
          const submitData = buildExperimentSubmitData(this.form, action)
          editAbTest(submitData)
            .then(() => {
              this.$Message.success('实验保存成功')
              this.$emit('submit', submitData)
            })
            .catch((err) => {
              this.$Message.error(err.msg || '实验保存失败')
            })
            .finally(() => {
              this.loading = false
            })
          return
        }

        editAbTest({
          id: this.form.id,
          experimentName: this.form.experimentName
        })
          .then(() => {
            this.$Message.success('实验保存成功')
            this.$emit('submit', {})
          })
          .catch((err) => {
            this.$Message.error(err.msg || '实验保存失败')
          })
          .finally(() => {
            this.loading = false
          })
      })
    }
  }
}
</script>

<style scoped lang="less">
.layout-card {
  /deep/ .ivu-card-body {
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: auto;
  }
}

.step-indicator {
  display: flex;
  align-items: center;
  margin-right: 40px;
  margin-bottom: 30px;
}

.step-indicator.vertical {
  flex-direction: column;
  align-items: flex-end;
  // gap: 30px;
  margin-right: 0;
  margin-bottom: 0;
}

.step-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
}

.step-indicator.vertical .step-item {
  display: flex;
  align-items: center;
  gap: 15px;
}

.step-number {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: #e8eaec;
  color: #86909c;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  transition: all 0.3s;
  position: relative;
  z-index: 2;
}

.step-title {
  font-size: 12px;
  color: #86909c;
  transition: all 0.3s;
  white-space: nowrap;
}

.step-line {
  width: 60px;
  height: 2px;
  background-color: #e8eaec;
  transition: all 0.3s;
}

.step-line.vertical {
  width: 2px;
  height: 60px;
  // margin-right: 11px;
  margin: 0 auto;
}

.step-item.active .step-number {
  background-color: #2d8cf0;
  color: #fff;
}

.step-item.active .step-title {
  color: #2d8cf0;
}

.step-line.active {
  background-color: #2d8cf0;
}

.step-item.completed .step-number {
  background-color: #52c41a !important;
  color: #fff;
}

.step-line.completed {
  background-color: #52c41a !important;
  color: #fff;
}

.button-group {
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
}
</style>
